import React from "react";

const Case = ({ width, position, color, direction, hasDropper, isBottom, isPerdelik = false }) => {
  const isSliding = (direction == 1 || direction == 4);
  
  const wheelBoxWidth = 0.06;
  const wheelBoxHeight = 0.06;
  const wheelBoxDepth = 0.03;

  return (
    <group position={position}>
      {/* Alt Profil */}
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[width + 0.02, 0.06, 0.05]} />
        <meshStandardMaterial color={color}  />
      </mesh>

      {/* Damlalık çıkıntısı */}
      {isBottom && hasDropper && (
        <group position={[0, -0.01, -0.02]} rotation={[Math.PI / 4, 0, 0]}>
          <mesh>
            <boxGeometry args={[width, 0.002, 0.04]} />
            <meshStandardMaterial color={color} />
          </mesh>
          <mesh position={[0, 0, +0.02725]} rotation={[0, 0, 0]}>
            <cylinderGeometry args={[0.007, 0.007, width, 32, 1, false, 0, 0]} />
            <meshStandardMaterial color={color} />
          </mesh>
        </group>
      )}

      {/* Teker Yuvası - Alt */}
      {isSliding && !isPerdelik && (
        <mesh position={[(direction == 1 ? -width : width )/2, -wheelBoxHeight / 2+0.03, -0.02]}>
          <boxGeometry args={[wheelBoxWidth, wheelBoxHeight, wheelBoxDepth]} />
          <meshStandardMaterial color="black" />
        </mesh>
      )}
    </group>
  );
};

export default Case;